export const SET_COMPLIANCE_FILTERS = "SET_COMPLIANCE_FILTERS";
export const RESET_COMPLIANCE_FILTERS = "RESET_COMPLIANCE_FILTERS";
